<template>
  <div class="">
    <span class="title">{{ config.allCheckText || '维度：' }}</span>
    <el-checkbox :indeterminate="indeterminate" v-model="checkAll" @change="handleCheckAllChange">{{
      config.allCheckText || '全选'
    }}</el-checkbox>
    <div class="dimens">
      <el-checkbox-group v-model="checkedDimens" @change="handleCheckedDimensChange">
        <el-checkbox v-for="(item, index) in dimensions" :label="item[labelKey]" :key="index" :disabled="item.disabled">
          {{ item.label }}
        </el-checkbox>

        <el-button type="text" @click="handleCheckAllChange">{{ config.clearText || '清空' }}</el-button>
      </el-checkbox-group>
    </div>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
export default {
  name: 'dimensionIndex',
  props: {
    dimensions: {
      type: Array,
      default() {
        return []
      }
    },
    config: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {},
  data() {
    return {
      labelKey: this.config.key || 'label',
      indeterminate: this.config.indeterminate,
      checkedDimens: [],
      checkAll: false
    }
  },
  watch: {
    checkedDimens: {
      handler(newVale) {
        this.indeterminate = this.checkedDimens.length !== 0 && this.checkedDimens.length !== this.dimensions.length
        this.checkAll = this.checkedDimens.length === this.dimensions.length
      },
      deep: true // 开启深度监听
    }
  },
  methods: {
    setData(dims) {
      const labels = this.dimensions.filter((d) => dims.includes(d.key)).map((d) => d.label)
      this.checkedDimens = labels
    },
    // 维度全选
    handleCheckAllChange(val) {
      val === true ? (this.checkedDimens = this.dimensions.map((item) => item[this.labelKey])) : this.initData()
      this.$emit('handleCheckAllChange', val, this.checkedDimens)
    },
    // 维度单个选中
    handleCheckedDimensChange(val) {
      this.checkedDimens = val
      this.$emit('handleCheckedDimensChange', val, this.checkedDimens)
    },
    initData() {
      this.checkedDimens = this.dimensions
        .filter((item) => item.checked === true)
        .map((mp) => {
          return mp[this.labelKey]
        })
    }
  },
  mounted() {
    this.initData()
  }
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.el-checkbox-group {
  display: inline-block;
}
.dimens {
  display: inline-block;
  margin-left: 10px;
  .el-checkbox {
    margin-right: 10px;
  }
}
</style>
